export default __webpack_public_path__ + "static/media/brands-workinghouse.0f476b95.webp";